import { Option } from './List'

const rules = {
    DynamicPositionHeader: {
        Component: null,
        defaultProps: {},
        label: 'Dynamic Position Header'
    }
} as {
    [ruleName: string]: {
        label: string
        Component: JSX.Element
        defaultProps: any
    }
}
function registerRule({ label, ruleName, defaultProps }: { ruleName: string; label: string; defaultProps: any }) {
    return ({ Component }: { Component: any }) => {
        rules[ruleName] = {
            Component,
            label,
            defaultProps
        }
    }
}

const getOptions = (): Option[] => {
    return Object.entries(rules).map(([key, value]) => {
        return {
            label: value.label,
            value: key
        }
    }) as Option[]
}

export { registerRule, rules, getOptions }
